import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that redirects to the appropriate dashboard based on user role.
 * - Membora system administrators (@membora.ai) → /system-admin
 * - All other users → /dashboard
 */
export const dashboardRedirectGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();

  if (!user) {
    return router.createUrlTree(['/launcher'], {
      queryParams: { returnUrl: state.url }
    });
  }

  // Check if user is a Membora platform administrator (by email domain)
  const isMemboraAdmin = user.email?.toLowerCase().endsWith('@membora.ai');

  if (isMemboraAdmin) {
    router.navigate(['/system-admin']);
    return false;
  }

  const memberPortalOrgId = authService.getAutoMemberPortalOrgId(user);
  if (memberPortalOrgId) {
    void authService.handoffToMemberPortal(memberPortalOrgId);
    return false;
  }

  const isSystemAdmin = user.orgRoleAssignments?.some(
    assignment =>
      assignment.orgStructure === 'ROOT' &&
      (assignment.roleNames?.includes('SystemAdmin') ||
       assignment.roleNames?.includes('Administrator') ||
       assignment.roleIds?.includes('aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa'))
  );

  if (isSystemAdmin) {
    router.navigate(['/system-admin']);
  } else {
    router.navigate(['/dashboard']);
  }

  return false; // Always return false since we're redirecting
};
